import { atom } from 'jotai';

import { assistantChatByShareTokenQueryAtom } from '../_graphql/queryAssistantChatByShareToken';

// 🔘🔘🔘 PLAIN ATOMS
export const $sharedChatToken = atom<string | null>(null);
export const $isSharedChatView = atom<boolean>(false);

// 🟢🟢🟢 REMOTE DATA
export const $sharedChatQuery = assistantChatByShareTokenQueryAtom((get) => {
  const token = get($sharedChatToken);
  return {
    variables: { token: token ?? '' },
    skip: !token,
  };
});
